import { getFirstControlOptionValue } from '../getFirstControlOptionValue';
import { coerceLayoutFieldValue } from './coerceLayoutFieldValue';
import { FormItem, GridInputValue } from '../../types/types';

// Definition default of a form item, in order: item `default`, control
// `default`, the first control option (radioBtn/combobox). undefined = the
// item has no default. The coercion guards against a string default on a
// numeric field.
export const getLayoutItemDefaultValue = (
  item: Omit<FormItem, 'handlerTriggers'>
): GridInputValue | undefined => {
  if (item.default !== undefined) {
    return coerceLayoutFieldValue(item.type, item.default);
  }

  const control = item.control;

  if (control && 'default' in control && control.default !== undefined) {
    return coerceLayoutFieldValue(item.type, control.default);
  }

  return getFirstControlOptionValue(control);
};
